import React, { memo } from "react";

const UnderOverCardMobile = ({ onBetting, t, item, isWin, oldResult }) => {
    const isWinner =
        isWin &&
        (oldResult?.oddEvenCode === item?.code ||
            oldResult?.underOverCode === item?.code);

    const handleClick = () => {
        if (typeof onBetting === "function") {
            onBetting(item);
        }
    };

    return (
        <button
            type="button"
            onClick={handleClick}
            className={`rbm-bet-card rbm-bet-card--${item?.code || ""} ${
                isWinner ? "is-winner" : ""
            }`}
        >
            <div className="rbm-bet-card__title">
                {t(`labels:betPrefix.${item?.code}`)}
            </div>

            <div className="rbm-bet-card__meta">
                <div className="rbm-bet-card__range">{item?.rangeNumber}</div>
                <div className="rbm-bet-card__odds">{item?.value}</div>
            </div>
        </button>
    );
};

export default memo(UnderOverCardMobile);